import { memo, useMemo } from "react";

import { cn } from "@/lib/chillnn/cn";

type Props = {
	adultNum: number;

	kidsNum: number;
	kidsNumAsCosleeping: number;
	kidsAgeArray: Array<number>;

	className?: string;
};

export const TotalPeopleText = memo(({ adultNum, kidsNum, kidsNumAsCosleeping, kidsAgeArray, className }: Props) => {
	/**
	 * 人数
	 */
	const totalPeopleText = useMemo(() => {
		let totalPeople = `大人${adultNum}人`;
		if (!kidsNum || !kidsAgeArray.length) return totalPeople;

		// 子どもの人数
		totalPeople += `, 子ども${kidsNum}人` + ` [${kidsAgeArray.map((age) => `${age}歳`).join(", ")}] `;

		// 添い寝の人数
		if (kidsNumAsCosleeping > 0) {
			totalPeople += ` ※ 添い寝${kidsNumAsCosleeping}人`;
		}

		return totalPeople;
	}, [adultNum, kidsAgeArray, kidsNum, kidsNumAsCosleeping]);

	return <p className={cn(className)}>{totalPeopleText}</p>;
});
